module.exports = __webpack_public_path__ + "img/notification.9066c399.png";